import {RESERVATION_CODE_LENGTH} from "../constants/reservation_constants";

export interface IReservationCodeDigitsChange {
    // omitted - the digits stay as they are, only the focus moves
    nextDigits?: string[];
    focusIndex: number;
}

export const getDigitsOnly = (value: string) => value.replace(/\D/g, "");

// a digit typed into an input that already holds one arrives next to the old digit - keep only the new one
export const dropKeptDigit = (typedDigits: string, keptDigit: string) => {
    if (keptDigit === "" || typedDigits.length !== 2) {
        return typedDigits;
    }

    if (typedDigits.startsWith(keptDigit)) {
        return typedDigits.slice(1);
    }

    return typedDigits.endsWith(keptDigit) ? typedDigits.slice(0, -1) : typedDigits;
};

const fillDigits = (digits: string[], startIndex: number, typedDigits: string) => {
    const nextDigits = [...digits];
    const insertedDigits = typedDigits.slice(0, digits.length - startIndex).split("");

    insertedDigits.forEach((digit, offset) => {
        nextDigits[startIndex + offset] = digit;
    });

    return {nextDigits, focusIndex: startIndex + insertedDigits.length};
};

// a whole code replaces the one entered so far, whichever input it lands in - anything shorter fills forward from that input
export const insertCodeDigits = (digits: string[], index: number, typedDigits: string) =>
    typedDigits.length >= RESERVATION_CODE_LENGTH ? fillDigits(createEmptyReservationDigits(), 0, typedDigits) : fillDigits(digits, index, typedDigits);

// null for a key the inputs leave to the browser
export const getCodeKeyDownChange = (key: string, index: number, digits: string[]): IReservationCodeDigitsChange | null => {
    if (key === "Backspace" && digits[index] === "" && index > 0) {
        const nextDigits = [...digits];
        nextDigits[index - 1] = "";

        return {nextDigits, focusIndex: index - 1};
    }

    if (key === "ArrowLeft" && index > 0) {
        return {focusIndex: index - 1};
    }

    if (key === "ArrowRight" && index < RESERVATION_CODE_LENGTH - 1) {
        return {focusIndex: index + 1};
    }

    return null;
};

export const createEmptyReservationDigits = () => Array<string>(RESERVATION_CODE_LENGTH).fill("");
import {RESERVATION_CODE_LENGTH} from "../constants/reservation_constants";

export interface IReservationCodeDigitsChange {
    // omitted - the digits stay as they are, only the focus moves
    nextDigits?: string[];
    focusIndex: number;
}

export const getDigitsOnly = (value: string) => value.replace(/\D/g, "");

// a digit typed into an input that already holds one arrives next to the old digit - keep only the new one
export const dropKeptDigit = (typedDigits: string, keptDigit: string) => {
    if (keptDigit === "" || typedDigits.length !== 2) {
        return typedDigits;
    }

    if (typedDigits.startsWith(keptDigit)) {
        return typedDigits.slice(1);
    }

    return typedDigits.endsWith(keptDigit) ? typedDigits.slice(0, -1) : typedDigits;
};

const fillDigits = (digits: string[], startIndex: number, typedDigits: string) => {
    const nextDigits = [...digits];
    const insertedDigits = typedDigits.slice(0, digits.length - startIndex).split("");

    insertedDigits.forEach((digit, offset) => {
        nextDigits[startIndex + offset] = digit;
    });

    return {nextDigits, focusIndex: startIndex + insertedDigits.length};
};

// a whole code replaces the one entered so far, whichever input it lands in - anything shorter fills forward from that input
export const insertCodeDigits = (digits: string[], index: number, typedDigits: string) =>
    typedDigits.length >= RESERVATION_CODE_LENGTH ? fillDigits(createEmptyReservationDigits(), 0, typedDigits) : fillDigits(digits, index, typedDigits);

// null for a key the inputs leave to the browser
export const getCodeKeyDownChange = (key: string, index: number, digits: string[]): IReservationCodeDigitsChange | null => {
    if (key === "Backspace" && digits[index] === "" && index > 0) {
        const nextDigits = [...digits];
        nextDigits[index - 1] = "";

        return {nextDigits, focusIndex: index - 1};
    }

    if (key === "ArrowLeft" && index > 0) {
        return {focusIndex: index - 1};
    }

    if (key === "ArrowRight" && index < RESERVATION_CODE_LENGTH - 1) {
        return {focusIndex: index + 1};
    }

    return null;
};

export const createEmptyReservationDigits = () => Array<string>(RESERVATION_CODE_LENGTH).fill("");
